import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, Card, CardHeader, CardBody, FormFeedback } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { reviewEvidence, updateStatusActivity } from '../../../../../slices/thunks';
import { reviewEvidence as reviewEvidenceApi } from '../../../../../helpers/normative/backend_helper';
import { createSelector } from 'reselect';
import { setRequireCloseModal, updateEvidenceReviewed } from '../../../../../slices/evidence/reducer';
import useFolderPaths from '../../../../../Components/Hooks/useFolderPathsHooks';
import useFileType from '../../../../../Components/Hooks/useFileTypeHooks';
import { DatePickerInput, DatesProvider } from '@mantine/dates';

import {
    getFile as onGetFile,
    downloadFile as onDownloadFile,
} from '../../../../../slices/thunks';
import dayjs from 'dayjs';

const ReviewEvidenceForm = ({ data, dataEvidence, handleToggleModal, isOpen, activeTab, toggleTab, showDetails }) => {

    const dispatch = useDispatch();
    const code_status_loaded = 'CRG';
    const [isApproved, setIsApproved] = useState(null);
    const [isSubmit, setIsSubmit] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [folderPaths, setFolderPaths] = useState([]);
    const [fileDownloadLoading, setFileDownloadLoading] = useState(null);

    const selectorEvidences = createSelector(
        state => state.Evidences,
        evidence => ({
            isReviewing: evidence.isReviewing,
            isReviewed: evidence.isReviewed,
            isReviewError: evidence.isReviewError,
            requireCloseModal: evidence.requireCloseModal
        })
    );

    const {
        isReviewing,
        requireCloseModal
    } = useSelector(selectorEvidences);

    const validation = useFormik({
        initialValues: {
            observation: ''
        },
        validationSchema: Yup.object({
            observation: Yup.string()
                .required('La observación es requerida')
        }),
        onSubmit: async (values) => {
            setIsSubmit(true);
            try {
                const repsonse = await dispatch(reviewEvidence({
                    _id: dataEvidence._id,
                    approved: isApproved,
                    observation: values.observation
                })).unwrap();
                const responseUpdate = await dispatch(updateStatusActivity({ _id: data._id, code: 'CMP' }));
            } catch (err) {
                console.error('error: ', err);
                setIsSubmit(false);
            }
        },
    });

    // useEffect(() => {
    // 	if (!isUpdating) {
    // 		setIsDisabled(false);
    // 	}
    // }, [isUpdating]);

    useEffect(() => {
        if (isOpen) {
            if (requireCloseModal) {
                dispatch(setRequireCloseModal(false));
                handleToggleModal();
            }
        }
    }, [requireCloseModal]);

    async function reviewEvidenceCloseModal() {
        let response = null;
        try {
            response = await reviewEvidenceApi({
                _id: dataEvidence._id,
                revised: true
            })
            console.log(response);
            dispatch(updateEvidenceReviewed(response))
        } catch (err) {
            console.error('Error al marcar como revisada la evidencia:', err);
        }

    }

    useEffect(() => {
        if (
            !isOpen &&
            !isSubmit &&
            dataEvidence?.evidence_status?.code == code_status_loaded
        ) {
            reviewEvidenceCloseModal();
        }
    }, [isOpen])

    useEffect(() => {
        if (isApproved != null) {
            validation.handleSubmit();
        }
        if (!validation.isValid) {
            setIsApproved(null);
        }
    }, [isApproved])

    return (
        <Form
            className='tablelist-form'
            onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
            }}
        >
            <ModalBody className='modal-body'>
                <TabContent activeTab={'1'}>
                    <TabPane tabId='1'>
                        <Row className='g-3'>
                            <React.Fragment>
                                <div className='px-2'>
                                    <Card className='p-0 border-1'>
                                        <CardHeader className='p-2'>
                                            <h5 className="card-title mb-0">
                                                Detalles de Evidencia
                                            </h5>
                                        </CardHeader>
                                        <CardBody className='p-2'>
                                            <ul className="list-unstyled mb-0 vstack gap-3">
                                                <li>
                                                    <div className='row d-flex'>
                                                        <div className="col-md-2">
                                                            <span className="text-muted">Evidencia Requerida</span>
                                                        </div>
                                                        <div className="col-md-10">
                                                            <div className="col-md-10">
                                                                <span>
                                                                    Requiere adjuntar archivo de "<span className='fw-bold text-decoration-underline'>{data.evidence_type.name}</span>" como evidencia de actividad ejecutada.
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className='row d-flex'>
                                                        <div className="col-md-2">
                                                            <span className="text-muted">Evidencia Cargada</span>
                                                        </div>
                                                        <div className="col-md-10">
                                                            <div className="col-md-10">
                                                                <span>
                                                                    <a
                                                                        className="link-opacity-100 flex-grow-1 fw-bold text-decoration-underline"
                                                                        href="#"
                                                                        title='Descargar Evidencia'
                                                                        onClick={e => {
                                                                            e.preventDefault();
                                                                            setFileDownloadLoading(
                                                                                dataEvidence.document[0]._id
                                                                            );
                                                                            dispatch(
                                                                                onDownloadFile({
                                                                                    file_id:
                                                                                        dataEvidence.document[0]._id,
                                                                                })
                                                                            )
                                                                                .then(data => {
                                                                                    const payload = data.payload;
                                                                                    const url =
                                                                                        window.URL.createObjectURL(
                                                                                            payload
                                                                                        );
                                                                                    const link =
                                                                                        document.createElement('a');
                                                                                    link.href = url;
                                                                                    link.setAttribute(
                                                                                        'download',
                                                                                        `${dataEvidence.document[0].filename}${dataEvidence.document[0].extension}`
                                                                                    );
                                                                                    document.body.appendChild(link);
                                                                                    link.click();
                                                                                })
                                                                                .finally(() =>
                                                                                    setFileDownloadLoading(null)
                                                                                );
                                                                        }} 
                                                                    >
                                                                        {dataEvidence.document[0].filename}
                                                                        {dataEvidence.document[0].extension}
                                                                    </a>
                                                                    {/* <span className='fw-bold text-decoration-underline'>{dataEvidence.document[0].name}</span> */}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className='row d-flex'>
                                                        <div className="col-md-2">
                                                            <span className="text-muted">Fecha de Carga</span>
                                                        </div>
                                                        <div className="col-md-10">
                                                            <span className='fw-semibold float-end w-100'>{(dayjs(dataEvidence.creation_date).format('DD-MM-YYYY HH:mm'))}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className='row d-flex'>
                                                        <div className="col-md-2">
                                                            <span className="text-muted">Actividad</span>
                                                        </div>
                                                        <div className="col-md-10">
                                                            <span className='fw-semibold float-end w-100'>{data.title}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className='row d-flex'>
                                                        <div className="col-md-2">
                                                            <span className="text-muted">Inicio</span>
                                                        </div>
                                                        <div className="col-md-10">
                                                            <span className='fw-semibold float-end w-100'>{(dayjs(data.start).format('DD-MM-YYYY HH:mm'))}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className='row d-flex'>
                                                        <div className="col-md-2">
                                                            <span className="text-muted">Fin</span>
                                                        </div>
                                                        <div className="col-md-10">
                                                            <span className='fw-semibold float-end w-100'>{(dayjs(data.end).format('DD-MM-YYYY HH:mm'))}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>

                                        </CardBody>
                                    </Card>
                                </div>
                            </React.Fragment>
                            <Col lg={12}>
                                <Label for='observation' className='form-label'>
                                    Observación
                                </Label>
                                <Input
                                    name='observation'
                                    id='observation'
                                    className='form-control'
                                    placeholder='Ingrese tu observación'
                                    type='textarea'
                                    validate={{ required: { value: true } }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.observation || ''}
                                    invalid={
                                        validation.touched.observation &&
                                            validation.errors.observation
                                            ? true
                                            : false
                                    }
                                    rows="5"

                                />
                                {
                                    validation.touched.observation &&
                                        validation.errors.observation ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.observation}
                                        </FormFeedback>
                                    ) : null
                                }
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody>
            <div className='modal-footer'>
                <div className='d-flex w-100 gap-2'>
                    <Button
                        type='button'
                        onClick={(e) => {
                            e.preventDefault();
                            setIsApproved(false);
                        }}
                        disabled={
                            isReviewing &&
                                !isApproved
                                ? true
                                : false
                        }
                        className='btn-danger btn-label flex-fill'
                    >
                        {
                            isReviewing &&
                                !isApproved
                                ? (
                                    <i className='label-icon'><Spinner size='sm' /></i>
                                ) : <i className="icon-x label-icon"></i>
                        }
                        Rechazar
                    </Button>
                    <button
                        type='button'
                        onClick={(e) => {
                            e.preventDefault();
                            setIsApproved(true);
                        }}
                        disabled={
                            isReviewing &&
                                isApproved
                                ? true
                                : false
                        }
                        className='btn btn-label btn-success flex-fill'
                    >
                        {
                            isReviewing &&
                                isApproved
                                ? (
                                    <i className='label-icon'><Spinner size='sm' /></i>
                                ) : <i className={`${Icons.check2} label-icon`}></i>
                        }
                        Aprobar
                    </button>
                </div>
            </div>
        </Form>
    );
};

export default ReviewEvidenceForm;